module.exports = __webpack_public_path__ + "static/media/node.2e61c1d7.jpg";